import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { Typography } from '@mui/material';
import React from 'react';
import { sxSubTitle } from '../../../assets/styles/CommonSxProps';
import { ItemCronogramaGC } from '../../../interfaces/entities/SaudeBemEstar/GestaoDeCronicos/ItemCronogramaGC';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { sxRegular, sxSemibold, sxTimelineConnector, sxTimelineDot } from './sxProps';
import TodayMarker from './TodayMarker';
import { getIcon } from '../../../utils/Icons';
import { dateToText } from '../../../utils/MonthMap';

const TimeLineGC: React.FC<{ items: ItemCronogramaGC[] }> = ({ items }) => {

  const accessibility = useAccessibility();

  return (
    <Timeline position="right">
      {
        items.map((item, i, itens) =>
          <React.Fragment key={i}>
            {(item.isHoje && !itens[i - 1].isHoje) &&
              <TodayMarker />
            }
            <TimelineItem sx={{ minHeight: 'unset' }} tabIndex={0} aria-label='BELEZA'>
              <TimelineSeparator>
                <TimelineDot sx={{ ...sxTimelineDot, backgroundColor: item.color }}>
                  <FontAwesomeIcon className='fa-icon22x22' icon={getIcon(item.icon)} />
                </TimelineDot>
                {i !== items.length - 1 && <TimelineConnector sx={sxTimelineConnector} />}
              </TimelineSeparator>
              <TimelineContent sx={{ padding: '4px 32px' }}>
                {item.descrStatus && (<>
                  <Typography aria-hidden style={accessibility.textStyleAccessibility} sx={{ ...sxRegular, marginBottom: '8px' }}>{item.data}</Typography>
                  <span className='sr-only'>{`${dateToText(item.data.split(' ')[0])} às ${item.data.split(' ')[1]}`}</span>
                </>)}
                <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSubTitle, marginBottom: '8px' }}>{item.descrAtendimento}</Typography>
                <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSemibold, marginBottom: '8px', color: '#717171' }} >{item.descrStatus}</Typography>
                <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSemibold, marginBottom: '8px', color: '#4C4C4C' }} >{item.tempoConsulta}</Typography>
              </TimelineContent>
              <TimelineOppositeContent display="none" />
            </TimelineItem>
          </React.Fragment>
        )}
    </Timeline>
  )
}

export default TimeLineGC;